import * as React from 'react'
import CheckMarker from '../icons/ui/CheckMarker'

export interface IRecurring {
  isOpen: boolean
  onToggle: () => void
  onSetDateData: (dateData: any) => void
  handleSetValue: (key: string, value: any) => void
}

const allMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

class Recurring extends React.Component<IRecurring, any> {
  constructor(props: IRecurring) {
    super(props)
    this.state = {
      months: []
    }
  }

  public onSelect = (month: string) => () => {
    let months: number[] = []
    this.state.months.indexOf(month) === -1
      ? (months = [...this.state.months, month])
      : (months = this.state.months.filter((item: string) => item !== month))
    this.setState({ months })
    this.props.handleSetValue('timeSetting', months)
  }

  public render() {
    return (
      <div className='flex flex-wrap mt2 items-start'>
        <div
          className='border-grey5 bg-white icon--small rounded cursor--pointer justify-center flex'
          onClick={this.props.onToggle}
        >
          {this.props.isOpen && <CheckMarker className='check-marker' />}
        </div>
        <span className='mr1 ml1 h6 font-dark-grey'>Recurring:</span>
        {this.props.isOpen && (
          <div className='flex flex-wrap ml2 mt2' style={{ width: 230 }}>
            {allMonths.map((item, key) => (
              <div key={key} className='flex items-center col-4 border-box mb2' onClick={this.onSelect(item)}>
                <div className='border-grey5 bg-white icon--small rounded cursor--pointer justify-center flex'>
                  {this.state.months.indexOf(item) !== -1 && <CheckMarker className='check-marker' />}
                </div>
                <span className='ml1 h6'>{item}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
}

export default Recurring



// WEBPACK FOOTER //
// ./src/components/membership-request/Recurring.tsx